import * as jose from 'jose';
import keys from '../constants/keys.json';

const JWKS = jose.createLocalJWKSet({ keys });

export const getUserName = async () => {
  const userInfo = await getUserInfo();
  return `${userInfo?.first_name || ''} ${userInfo?.last_name || ''}`;
};

export const getUserEmail = async () => {
  const userInfo = await getUserInfo();
  return userInfo?.email || null;
};

export const getUserId = async () => {
  const userInfo = await getUserInfo();
  return userInfo?.sub || null;
};

export const getUserInfo = async () => {
  try {
    const idToken = localStorage.getItem('id_token');
    const { payload } = await jose.jwtVerify(idToken, JWKS);
    return payload;
  }
  catch (ex) {
    return null;
  }
};

export const getUserType = async () => {
  const userInfo = await getUserInfo();
  return typeof userInfo?.type === 'number' ? userInfo.type : null;
};

export const getTcnCustomerId = async () => {
  const userInfo = await getUserInfo();
  return userInfo?.tcnCustomerId || null;
};

export const getCustomerId = async () => {
  const userInfo = await getUserInfo();
  return userInfo?.customerId || null;
};

export const getApplyAgentIssuanceOnly = async () => {
  const userInfo = await getUserInfo();
  return userInfo?.applyAgentIssuanceOnly === "TRUE";
};

export const getCustomerAllowUpdateStatus = async () => {
  const userInfo = await getUserInfo();
  return userInfo?.customerAllowUpdateStatus === "TRUE";
};

export const getDepartmentName = async () => {
  const userInfo = await getUserInfo();
  return userInfo?.department?.name || null;
};

export const getOtpAllowed = async () => {
  try {
    const mfaToken = localStorage.getItem('mfa_token');
    const { payload } = await jose.jwtVerify(mfaToken, JWKS); // Add and audience issuer validation
    return payload?.otp_allowed === true;
  }
  catch (ex) {
    return null;
  }
};

export const getAuthToken = () => {
  return localStorage.getItem('auth_token');
};

export const getMfaToken = () => {
  return localStorage.getItem('mfa_token');
};

export const setAuthToken = (token) => {
  localStorage.setItem('auth_token', token);
};

export const setIdToken = (token) => {
  localStorage.setItem('id_token', token);
};

export const setMfaToken = (token) => {
  localStorage.setItem("mfa_token", token);
};

export const removeMfaToken = () => {
  localStorage.removeItem("mfa_token");
};

export const clearStorage = () => {
  localStorage.removeItem('mfa_token');
  localStorage.removeItem('auth_token');
  localStorage.removeItem('id_token');
};
